import React from "react"

import { IKTRichText } from "@/types/kontent.types"
import { getSyncDictionary } from "@/lib/sync-dictionary"
import { cn, ensureHttpUrl } from "@/lib/utils"
import { Link, RichTextSync } from "@/components/ui/atoms"
import { Picture } from "@/components/ui/molecules"

type TCardPartenaireProps = {
  src?: string
  alt?: string
  title: string
  body?: IKTRichText
  className?: string
  link?: string
  linkText?: string
}

const CardPartenaire = ({
  title,
  body,
  src,
  alt,
  link,
  linkText,
  className,
}: TCardPartenaireProps) => {
  const formattedLink = ensureHttpUrl(link)

  return (
    <article
      className={cn(
        "card-partenaire mx-auto flex max-w-[1000px] flex-col items-stretch rounded-100 bg-neutral-100 lg:flex-row",
        className
      )}
    >
      {src ? (
        <>
          <Picture
            src={src + "?h=400&w=400&fm=webp&q=80"}
            alt={alt ? alt : ""}
            width={200}
            height={200}
            isRounded={false}
            variant={"default"}
            className="card-partenaire--img hidden min-h-[200px] w-[200px] shrink-0 lg:block"
          />
          <Picture
            src={src + "?h=3200&w=900&fm=webp&q=80"}
            alt={alt ? alt : ""}
            width={800}
            height={225}
            isRounded={false}
            variant={"default"}
            alignLeft={true}
            className="card-partenaire--img h-[225px] max-h-[225px] min-h-[225px] shrink-0 overflow-hidden lg:hidden"
          />
        </>
      ) : null}
      <div className="flex size-full flex-col justify-between p-6 lg:p-7">
        <div>
          <header>
            <h2 className="heading-s pb-5 leading-[125%]">{title}</h2>
          </header>
          <span className="paragraph-m text-neutral-400">
            {body ? (
              <RichTextSync className="pb-7" blockTitle={title} body={body} />
            ) : null}
          </span>
        </div>

        {link ? (
          <div className="flex justify-end">
            <Link
              chapters={[
                title,
                linkText || getSyncDictionary().page.partenaires.seeSite,
              ]}
              variant="ghost"
              iconRight="ExternalLinkLine"
              className="p-0"
              href={formattedLink}
              target="_blank"
            >
              {linkText || getSyncDictionary().page.partenaires.seeSite}
            </Link>
          </div>
        ) : null}
      </div>
    </article>
  )
}

export { CardPartenaire, type TCardPartenaireProps }
